import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityTransactionsFilterDTO  {
    _originalTypeClassName = "zERP.BO.TransactionEntityTransactionsFilterDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityTransactionsFilterDTO.translate = translateService;
}
this.IsIncome = false;
this.IsExpense = false;
this.PaymentOrders = false;
this.Payments = false;
this.Receipts = false;
this.PaymentReceipts = false;
this.TransactionEntityTransactionsFilterDTOKey = null;
this._key = this.TransactionEntityTransactionsFilterDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
IsIncome:any;
IsExpense:any;
PaymentOrders:any;
Payments:any;
Receipts:any;
PaymentReceipts:any;
private _TransactionEntityTransactionsFilterDTOKey:any;
get TransactionEntityTransactionsFilterDTOKey(): any {
    return this._TransactionEntityTransactionsFilterDTOKey;
  }
set TransactionEntityTransactionsFilterDTOKey(value: any) {
    this._TransactionEntityTransactionsFilterDTOKey = value;
    this._key = value;
  }

static Init($this: any): any{$this.IsExpense = true;
$this.IsIncome = true;
$this.PaymentOrders = true;
$this.PaymentReceipts = true;
$this.Payments = true;
$this.Receipts = true;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityTransactionsFilterDTOKey == null || $this.TransactionEntityTransactionsFilterDTOKey == 0;
            }


}